<template>
  <div>
    <v-layout row
              v-if="parkingIsOffline"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning">
              <span v-html="$t('reservation.advice.parkingOffline')"></span>
            </advice>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              v-else-if="parkingIsComingSoon"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="primary">
              <span v-html="$t('reservation.advice.parkingComingSoon')"></span>
            </advice>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              v-else-if="parkingIsBuilding"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="primary">
              <span v-html="$t('reservation.advice.parkingBuilding')"></span>
            </advice>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row
              v-else-if="parkingIsMaintenance"
              wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title>
            <advice color="warning" v-html="$t('reservation.advice.parkingMaintenance')">
            </advice>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import parkingService from '@/services/parkingService';
import Advice from '@/components/commons/Advice';

export default {
  name: 'ParkingNonAvailable',
  components: {
    [Advice.name]: Advice
  },
  props: {
    parking: {
      type: Object,
      required: true
    }
  },
  computed: {
    parkingIsOffline() {
      return parkingService.isOfflineParking(this.parking)
    },
    parkingIsComingSoon() {
      return parkingService.isBuildingParking(this.parking)
    },
    parkingIsBuilding() {
      return parkingService.isBuildingParking(this.parking)
    },
    parkingIsMaintenance() {
      return parkingService.isMaintenanceParking(this.parking)
    }
  },
  data() {
    return {
    };
  }
};
</script>
